export const isNetworkError = (error: Error | { message: string }): boolean => {
  // Only treat as a real network problem when the browser reports offline
  // OR the error is an explicit fetch/network failure. Substring "fetch"
  // alone produced false positives on benign auth errors.
  if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
  const msg = (error.message || "").toLowerCase();
  return (
    msg.includes("failed to fetch") ||
    msg.includes("networkerror") ||
    msg.includes("err_internet") ||
    msg.includes("err_network") ||
    msg.includes("network request failed")
  );
};
